import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.vfs = pdfFonts.pdfMake.vfs;

function Impressao(clientes) {


  const dados = clientes.map((cliente) => {
    return [
      { text: cliente.nomeCompleto, fontSize: 10, margin: [0, 1, 0, 1] },
      { text: cliente.CPF, fontSize: 10, margin: [0, 1, 0, 1] },
      { text: cliente.protocolo, fontSize: 10, margin: [0, 1, 0, 1] },
      { text: cliente.data, fontSize: 10, margin: [0, 1, 0, 1] },
    ]
  });

  const details = [
    {
      text: 'PROTOCOLO DO CADASTRO DE DEMANDA PARA\nHABITAÇÃO DE INTERESSE SOCIAL',
      margin: [0, 35, 0, 15],
      style: {
        fontSize: 14,
        bold: true,
        alignment: 'center',
      },
    },
    {
      text: 'Parabéns, você realizou/atualizou seu cadastro com sucesso!\n\nAtualize seu cadastro pelo menos 1 vez no ano\n\nMuito Obrigado!\n\n\n',
      fontSize: 12,
      bold: true,
      width: 280,
      alignment: 'center',
      margin: [15, 25, 0, 15], // left, top, right, bottom
    },
    {
      table: {
        headerRows: 1,
        body: [
          [
            [{ text: 'Nome: ', fontSize: 12, alignment: 'center', }],
            [{ text: 'CPF: ', fontSize: 12, alignment: 'center', }],
            [{ text: 'Protocolo: ', fontSize: 12, alignment: 'center', }],
            [{ text: 'Data: ', fontSize: 12, alignment: 'center', }],
          ],
          ...dados,
        ],
      },
      margin: [70, 10, 70, 0],
      layout: 'lightHorizontalLines',
    },
  ];


  var dataAtual = new Date();
  var dia = String(dataAtual.getDate()).padStart(2, '0');
  var mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
  var ano = dataAtual.getFullYear();
  dataAtual = dia + '/' + mes + '/' + ano;
  function Rodape(currentPage, pageCount) {
    return [
      {
        text: dataAtual,
        alignment: 'right',
        fontSize: 9,
        margin: [0, 10, 20, 0] // left, top, right, bottom
      }
    ]
  }

  const docDefinitios = {
    pageSize: 'A4',
    alignment: 'center',
    pageMargins: [15, 50, 15, 40],

    content: [details],
    footer: Rodape
  }

  pdfMake.createPdf(docDefinitios).download();
}

export default Impressao;